﻿export const upOrDownOnScrollWheel = (elm: HTMLElement) => {
    let lastScrollPos = 0;
    const navLists = elm.querySelectorAll(".hasChildren");
    const navIcons = elm.querySelectorAll(".icon");

    window.addEventListener("scroll", function () {
        const currentScroll = window.scrollY;

        if (currentScroll <= 0 && lastScrollPos < 0) {
            elm.classList.remove("scroll-up");
            elm.classList.remove("scroll-down");
        }

        if (currentScroll > lastScrollPos) {
            elm.classList.add("scroll-down");
            if (elm.classList.contains("scroll-up")) {
                elm.classList.remove("scroll-up");
            }
            navLists.forEach((navList) => navList.classList.remove("open"));
            navIcons.forEach((navIcon) => navIcon.classList.remove("active"));
        } else {
            elm.classList.add("scroll-up");
            elm.classList.remove("scroll-down");
        }

        if (currentScroll === 0) {
            elm.classList.remove("scroll-up");
        }

        lastScrollPos = currentScroll;
    });
};

export const closeBackDrop = (fn?: Function) => {
    const backgdrop = document.querySelector<HTMLElement>(".general-modal-bg");

    if (!backgdrop) return;

    if (!backgdrop || !fn) return;

    backgdrop.addEventListener("click", (event) => {
        if (fn) {
            fn();
        }
        
        backgdrop.classList.add("general-modal-bg--hidden");
    });

    window.addEventListener("keydown", (event: KeyboardEvent) => {
        if (
            event.key === "Escape" &&
            !backgdrop.classList.contains("general-modal-bg--hidden")
        ) {
            if (fn) {
                fn();
            }

            backgdrop.classList.add("general-modal-bg--hidden");
        }
    });
};

export const isElementOutOfViewport = (el) => {
    const rect = el.getBoundingClientRect();
    const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
    const windowWidth =
        window.innerWidth || document.documentElement.clientWidth;

    return (
        rect.bottom < 0 ||
        rect.right < 0 ||
        rect.left > windowWidth ||
        rect.top > windowHeight
    );
};

export function pipe(...functions) {
    return function (value) {
        return functions.reduce((currentyValue, currentFunction) => {
            return currentFunction(currentyValue);
        }, value);
    };
}

export const debounce = (func: Function, wait: number = 250) => {
    let timeout: ReturnType<typeof setTimeout>;

    return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func();
        }, wait);
    };
};
